export default __webpack_public_path__ + "static/media/playstation@2x.e821ce4f.webp";